import { isAbsoluteWidth } from './isAbsoluteWidth.es.js';

const buildSizes = (w) => {
  if (isAbsoluteWidth(w))
    return `${w.value}${w.unit}`;
  return `${w.value}vw`;
};

export { buildSizes };
